export enum ReplacementOriginType {
    PROCESS,
    IMPORTED,
    MERGED_WITH_LIST,
    MERGED_WITH_PROCESS
}
